{
  "switchOffice": "Switch office",
  "noOfficeTitle": "You're not in an office yet",
  "noOfficeBody": "Ask your office head or the LGU administrator to add you to your office.",
  "navDashboard": "Dashboard",
  "navPosts": "Posts & events",
  "navCheckin": "Check-in",
  "navDispatch": "Dispatch",
  "navCrop": "Crop damage",
  "navSafety": "Safety map",
  "navEmergencyMode": "Emergency mode",
  "navProfile": "Office profile",
  "navTeam": "Staff",
  "navAdminHome": "Overview",
  "navOffices": "Offices",
  "navStaffAccounts": "Staff accounts",
  "navSettings": "LGU settings",
  "navHotlines": "Hotlines",
  "navResponders": "Responder teams",
  "navDisasterEvents": "Disaster events",
  "navCategories": "Categories",
  "navAudit": "Audit log",
  "navSmsLog": "SMS log",
  "role_viewer": "Viewer",
  "role_contributor": "Contributor",
  "role_editor": "Editor",
  "role_office_head": "Office head",
  "readOnly": "You have view-only access in this office.",
  "newPost": "New post",
  "type_announcement": "Announcement",
  "type_schedule": "Schedule",
  "type_program": "Program",
  "urgent": "Urgent",
  "pinned": "Pinned",
  "status_draft": "Draft",
  "status_pending_approval": "Waiting for approval",
  "status_published": "Published",
  "status_archived": "Archived",
  "status_scheduled": "Scheduled",
  "status_cancelled": "Cancelled",
  "filter_pending_approval": "Waiting for approval",
  "filter_draft": "Drafts",
  "filter_published": "Published",
  "filter_scheduled": "Scheduled",
  "filter_archived": "Archived",
  "statPublished": "Published posts",
  "statScheduled": "{count} scheduled to publish",
  "statViews": "Post views",
  "statRegistrations": "Registrations",
  "statAttendance": "Attendance",
  "last30": "Last 30 days",
  "attendanceOf": "{attended} of {expected} checked in (last 90 days)",
  "attendanceNone": "No finished events with registration yet",
  "pendingApprovals": "Waiting for approval",
  "noPendingApprovals": "Nothing is waiting for approval.",
  "submittedBy": "From {name} · {date}",
  "review": "Review",
  "needsReview": "Registrations to review",
  "noNeedsReview": "No registrations are waiting for your decision.",
  "pendingCount": "{count} pending",
  "confirmedCount": "{count} confirmed",
  "waitlistCount": "{count} on waitlist",
  "upcoming": "Upcoming events",
  "allPosts": "All posts",
  "noUpcoming": "No upcoming events",
  "noUpcomingBody": "Post a schedule or program so residents know what's coming.",
  "noRegistration": "No registration for this event.",
  "registered": "Registered",
  "registrants": "Registrants",
  "seatsOf": "{taken} of {capacity}",
  "seatsNoLimit": "{taken} registered · no limit",
  "capacity": "Capacity",
  "postsLead": "Announcements, schedules and programs from your office.",
  "searchPosts": "Search titles",
  "noPosts": "No posts yet",
  "noPostsBody": "Your office's announcements, schedules and programs will appear here.",
  "noPostsMatch": "No posts match",
  "publishesOn": "Publishes {date}",
  "updatedBy": "{name}, {date}",
  "registeredShort": "registered",
  "viewsShort": "views",
  "viewPublic": "View as residents see it",
  "reviewTitle": "Review this post",
  "reviewLead": "Publish it now, or return it to the author with a note on what to change.",
  "reviewNote": "Note to the author",
  "reviewNoteHint": "Required when returning the post.",
  "returnNoteRequired": "Tell the author what to change.",
  "approvePublish": "Approve and publish",
  "returnToDraft": "Return with note",
  "openEditor": "Open in editor",
  "approved": "Approved and published.",
  "returned": "Returned to the author.",
  "checkinLead": "Scan the resident's QR ticket, or search by name or mobile number.",
  "checkinEvent": "Event",
  "checkinAnyEvent": "Any of our events",
  "checkinEventHint": "Tickets for other events will be refused.",
  "checkinAnyHint": "Pick the event at this door so tickets for other events are caught.",
  "checkinMode": "How to check in",
  "checkinEditorsOnly": "Only editors and office heads can check people in.",
  "checkinOffline": "No connection. Check the person's name on their ticket and try again when you're back online.",
  "arrived": "Checked in",
  "scanQr": "Scan QR",
  "searchName": "Search name",
  "startCamera": "Start camera",
  "stopCamera": "Stop camera",
  "cameraView": "Camera view for scanning tickets",
  "cameraDenied": "Camera access is blocked. Allow the camera in your browser settings, or type the ticket code below.",
  "cameraError": "The camera couldn't start. Type the ticket code below or use name search.",
  "ticketCode": "Ticket code",
  "ticketCodePlaceholder": "Or type the code",
  "ticketNotFound": "No ticket with that code for this office.",
  "searchPlaceholder": "Name, mobile number or ticket code",
  "searchNoMatch": "No one found. Check the spelling or try their mobile number.",
  "otherEvent": "Other event",
  "outcomeOk": "Checked in",
  "outcomeAlready": "Already checked in",
  "outcomeWrongEvent": "Wrong event",
  "outcomeNotConfirmed": "Not confirmed",
  "outcomeNotFound": "Ticket not found",
  "alreadyAt": "Checked in at {time}.",
  "nextPerson": "Next person",
  "profileLead": "What residents see on your office's page.",
  "viewPublicProfile": "View public page",
  "headOnly": "Only the office head can change this.",
  "officeType_municipal": "Municipal office",
  "officeType_barangay": "Barangay",
  "nameByAdmin": "The LGU administrator manages office names.",
  "uploadLogo": "Upload logo",
  "replaceLogo": "Replace logo",
  "removeLogo": "Remove logo",
  "icon": "Icon (shown when there is no logo)",
  "description": "About this office",
  "descriptionHint": "What the office does and which services residents can get here.",
  "location": "Location",
  "locationHint": "e.g. 2nd floor, Municipal Hall",
  "officeHours": "Office hours",
  "officeHoursHint": "e.g. Monday to Friday, 8:00 AM – 5:00 PM",
  "contact": "Contact details",
  "contactPhone": "Phone",
  "contactOther": "Other contact",
  "contactOtherHint": "e.g. Facebook page or a second number",
  "mapLocation": "Map location",
  "mapLocationHint": "Optional. Helps residents find the office.",
  "profileSaved": "Office profile saved.",
  "lastUpdated": "Last updated {date}",
  "teamLead": "People who can work for {office} in this app.",
  "inviteTitle": "Invite staff",
  "inviteLead": "Use the person's official office email. They get a link to set their password. Staff never sign up on their own.",
  "inviteEmail": "Email address",
  "role": "Role",
  "sendInvite": "Send invite",
  "inviteSent": "Invitation sent to {email}.",
  "inviteCreated": "Invitation created. Email isn't set up, so share the link below.",
  "memberAdded": "{email} was added to this office.",
  "memberUpdated": "{email}'s role was updated.",
  "inviteLinkTitle": "Send this link to the person",
  "inviteLinkBody": "Email isn't set up yet, so the invitation wasn't emailed. Send this link privately (it works for 7 days).",
  "copyLink": "Copy link",
  "noStaff": "No staff yet",
  "teamList": "Staff ({count})",
  "you": "you",
  "statusInvited": "Invited",
  "statusDeactivated": "Deactivated",
  "lastSignIn": "Last signed in {date}",
  "neverSignedIn": "Has not signed in yet",
  "roleFor": "Role for {name}",
  "roleChanged": "{name} is now {role}.",
  "removeFromOffice": "Remove {name} from this office",
  "confirmRemove": "Remove {name} from {office}? They lose access to this office right away.",
  "removed": "{name} was removed from this office.",
  "deactivateNote": "Someone leaving the LGU? The administrator can deactivate their account entirely.",
  "rolesExplained": "What each role can do",
  "roleHelp_office_head": "Manages staff and the office profile, plus everything editors can do.",
  "roleHelp_editor": "Publishes posts, approves contributors' drafts, manages registrations and check-in.",
  "roleHelp_contributor": "Writes drafts and sends them for approval.",
  "roleHelp_viewer": "Can see posts and registrations, but can't change anything.",
  "navRequests": "Requests",
  "navServices": "Services & charter",
  "navAlerts": "Urgent alerts",
  "navFeedback": "Feedback",
  "navReportCategories": "Concern types",
  "navHolidays": "Holidays",
  "navRevenue": "Revenue desk",
  "navGuides": "Town guides",
  "navMarketPrices": "Market prices",
  "navRecycling": "Recyclables pickup",
  "navFacilities": "Facilities",
  "navModeration": "Community moderation",
  "navTourism": "Tourism",
  "navTransparency": "Transparency",
  "navOrdinances": "Ordinances",
  "navTownGuides": "Town guides",
  "navHq": "Headquarters",
  "openHq": "Open headquarters"
}
